import { useState } from "react";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS, CONTACT } from "@/data/site";

export const ServiceAreaMap = ({ compact = false }) => {
  const [active, setActive] = useState(SERVICE_AREAS[0]);
  const zoom = active.office ? 9 : 12;
  const src = `https://www.google.com/maps?q=${encodeURIComponent(active.q)}&z=${zoom}&output=embed`;

  return (
    <div className="grid lg:grid-cols-12 gap-6 items-stretch" data-testid="service-area-map">
      <div className="lg:col-span-4 flex flex-col">
        <div className="rounded-3xl bg-navy text-white p-6 mb-4">
          <div className="flex items-start gap-3">
            <MapPin className="w-5 h-5 text-leaf mt-1 shrink-0" />
            <div>
              <p className="text-xs uppercase tracking-widest text-white/50">Service area</p>
              <p className="font-medium leading-snug" data-testid="office-address">{CONTACT.area}</p>
            </div>
          </div>
        </div>
        <p className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Hover a city to explore our service area</p>
        <div className="flex flex-wrap gap-2">
          {SERVICE_AREAS.filter((a) => !a.office).map((a) => (
            <button
              key={a.name}
              onMouseEnter={() => setActive(a)}
              onFocus={() => setActive(a)}
              onClick={() => setActive(a)}
              data-testid={`area-chip-${a.name}`}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-all duration-200 ${active.name === a.name ? "bg-leaf text-white border-leaf scale-105" : "bg-white text-navy border-border hover:border-leaf"}`}>
              {a.name}
            </button>
          ))}
          <button
            onMouseEnter={() => setActive(SERVICE_AREAS[0])}
            onClick={() => setActive(SERVICE_AREAS[0])}
            data-testid="area-chip-office"
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-all duration-200 ${active.office ? "bg-navy text-white border-navy scale-105" : "bg-white text-navy border-border hover:border-navy"}`}>
            📍 Our Office
          </button>
        </div>
      </div>

      <div className="lg:col-span-8">
        <div className={`relative rounded-[2rem] overflow-hidden border border-border shadow-xl ${compact ? "aspect-[16/10]" : "aspect-[16/10] lg:aspect-auto lg:h-full lg:min-h-[440px]"}`}>
          <iframe
            key={active.q}
            title={`CJB Clean service area — ${active.name}`}
            data-testid="dmv-map"
            src={src}
            width="100%" height="100%" style={{ border: 0 }}
            loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen
            className="absolute inset-0 w-full h-full" />
          <div className="absolute top-4 left-4 bg-white/90 backdrop-blur px-4 py-2 rounded-full text-sm font-medium text-navy shadow-md pointer-events-none" data-testid="map-active-label">
            {active.office ? "CJB Clean — Northern VA, DC & MD" : `Now viewing: ${active.name}`}
          </div>
        </div>
      </div>
    </div>
  );
};
